import { useEffect, useState } from 'react'

import iconCalendar from '../../../assets/images/icon_calendar.svg'
import iconExpand from '../../../assets/images/icon_expand.svg'
import { Icon } from '../../common/Icon'
import { LoadingIndicator } from '../../common/LoadingIndicator'

import { formatCaptureDate } from './reviewTaskFormat'
import {
  ReviewPreviewCard,
  ReviewPreviewEmpty,
  ReviewPreviewExpand,
  ReviewPreviewHeader,
  ReviewPreviewImage,
  ReviewPreviewImageWrap,
} from './styles'

interface ReviewPreviewPopupProps {
  date?: string | null
  imageUrl?: string | null
  loading?: boolean
  onExpand: () => void
}

export const ReviewPreviewPopup = ({
  date,
  imageUrl,
  loading,
  onExpand,
}: ReviewPreviewPopupProps) => {
  const [imageReady, setImageReady] = useState(false)

  useEffect(() => {
    setImageReady(false)
  }, [imageUrl])

  const showSpinner = loading || !!(imageUrl && !imageReady)

  return (
    <ReviewPreviewCard>
      <ReviewPreviewHeader>
        <div style={{ display: 'flex', alignItems: 'center', marginLeft: 8 }}>
          <Icon icon={iconCalendar} size={14} style={{ marginRight: 9 }} />
          {formatCaptureDate(date) || 'Loading capture'}
        </div>
      </ReviewPreviewHeader>
      <ReviewPreviewImageWrap>
        {imageUrl && (
          <ReviewPreviewImage
            src={imageUrl}
            alt=""
            onLoad={() => setImageReady(true)}
            style={{ visibility: imageReady ? 'visible' : 'hidden' }}
          />
        )}
        {showSpinner && (
          <ReviewPreviewEmpty
            style={
              imageUrl
                ? { position: 'absolute', inset: 0, background: '#fff' }
                : undefined
            }
          >
            <LoadingIndicator
              fb
              containerStyle={{ background: 'transparent', height: '100%' }}
            />
          </ReviewPreviewEmpty>
        )}
        {!showSpinner && !imageUrl && (
          <ReviewPreviewEmpty>No Image</ReviewPreviewEmpty>
        )}
        <ReviewPreviewExpand type="button" onClick={onExpand} aria-label="Open review">
          <img src={iconExpand} alt="" />
        </ReviewPreviewExpand>
      </ReviewPreviewImageWrap>
    </ReviewPreviewCard>
  )
}
